// extracted by mini-css-extract-plugin
export default {"btnSubmit":"BtnApplyNewRate_btnSubmit__Ok90P"};